import * as api from '../coOpApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
    coOpActionCreators,
    CoOpActionKeys,
    ICoOpGlobalSettings,
    UpdateCoOpGlobalSettings
    } from '..';
import { uiActionCreators } from '../../ui';

function* updateCoOpGlobalSettingsSaga(action: UpdateCoOpGlobalSettings) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: ICoOpGlobalSettings = yield call(api.updateCoOpGlobalSettings, action.payload);

  yield put(coOpActionCreators.setGlobalSettings(response));
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateCoOpGlobalSettings() {
  yield takeEvery(CoOpActionKeys.UPDATE_COOP_GLOBAL_SETTINGS, updateCoOpGlobalSettingsSaga);
}
